(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deal-grid"] && !Shopify.designMode) return;
  try {
    
  function greyDealDaysAgo(dateString){if(!dateString)return Infinity;const date=new Date(dateString+'T00:00:00Z');if(Number.isNaN(date.getTime()))return Infinity;return(Date.now()-date.getTime())/86400000}
  const grid=document.getElementById('deals-grid');
  if(grid){
    const cards=Array.from(grid.querySelectorAll('.deal-card'));const empty=document.getElementById('deals-grid-empty');const bar=document.getElementById('deals-filterbar');
    const applyFilter=(kind,value)=>{let visible=0;cards.forEach(card=>{let show=true;if(kind==='category')show=card.dataset.category===value;if(value==='last-chance')show=card.dataset.lastChance==='true';card.parentElement.hidden=!show;if(show)visible+=1});if(empty)empty.hidden=visible>0};
    bar?.addEventListener('click',event=>{const button=event.target.closest('[data-deal-filter],[data-deal-category],[data-deal-sort]');if(!button)return;bar.querySelectorAll('.deals-chip').forEach(chip=>chip.classList.remove('is-active'));button.classList.add('is-active');if(button.dataset.dealSort==='percent-desc'){Array.from(grid.children).sort((a,b)=>Number(b.querySelector('.deal-card').dataset.percentage)-Number(a.querySelector('.deal-card').dataset.percentage)).forEach(item=>grid.appendChild(item));applyFilter('all','all')}else if(button.dataset.dealCategory){applyFilter('category',button.dataset.dealCategory)}else{applyFilter('filter',button.dataset.dealFilter)}});
    const track=document.getElementById('deals-fresh-track');const freshEmpty=document.getElementById('deals-fresh-empty');const freshFilters=document.querySelector('.deals-fresh__filters');
    const renderFresh=mode=>{if(!track)return;track.replaceChildren();let pool=cards.slice();if(mode==='24h')pool=pool.filter(card=>greyDealDaysAgo(card.dataset.dropdate)<=1);if(mode==='7d')pool=pool.filter(card=>greyDealDaysAgo(card.dataset.dropdate)<=7);if(mode==='top')pool.sort((a,b)=>Number(b.dataset.percentage)-Number(a.dataset.percentage));pool.slice(0,6).forEach(card=>track.appendChild(card.cloneNode(true)));if(freshEmpty)freshEmpty.hidden=pool.length>0};
    freshFilters?.addEventListener('click',event=>{const button=event.target.closest('[data-fresh-filter]');if(!button)return;freshFilters.querySelectorAll('.deals-chip').forEach(chip=>chip.classList.remove('is-active'));button.classList.add('is-active');renderFresh(button.dataset.freshFilter)});renderFresh('24h')
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grey-product-delivery"]) return;
  try {
    
document.querySelectorAll('[data-grey-product-delivery]').forEach((root)=>{
  const panel=root.querySelector('[data-gpa-panel]')
  const result=root.querySelector('[data-gpa-result]')
  const masterElement=document.getElementById('GreyDeliveryZoneMaster')
  let master={}
  try{master=JSON.parse(masterElement?.textContent||'{}')}catch(error){master={}}
  const classAliases={small:'S',small_parcel:'S',standard:'M',large:'L',large_bulky:'L'}
  const rawClass=(root.dataset.deliveryClass||'unclassified').trim()
  const deliveryClass=(classAliases[rawClass]||rawClass).toUpperCase()
  const schedule=master.delivery_schedule||{}
  const pricing=master.pricing_engine||{}
  const carrierEngine=master.carrier_decision_engine||{}
  const overrideElement=root.previousElementSibling?.matches('[data-grey-product-pricing-override]')?root.previousElementSibling:null
  let productOverride=null
  try{productOverride=JSON.parse(overrideElement?.textContent||'null')}catch(error){productOverride=null}
  const matchesRule=(rule,context)=>[
    ['zone',context.zone],
    ['delivery_class',context.deliveryClass],
    ['transport_method',context.transportMethod]
  ].every(([key,value])=>rule[key]===null||rule[key]===undefined||rule[key]===value)
  const resolvePricing=(context={})=>{
    const normalized={
      zone:context.zone||null,
      deliveryClass:(context.deliveryClass||deliveryClass||'unclassified').toUpperCase(),
      transportMethod:context.transportMethod||master.delivery_schedule?.default_method||null,
      cartSubtotal:Number.isFinite(Number(context.cartSubtotal))?Number(context.cartSubtotal):null,
      extraLaborRequired:Boolean(context.extraLaborRequired)
    }
    const rule=(pricing.rules||[]).filter((candidate)=>matchesRule(candidate,normalized)).sort((a,b)=>(b.priority||0)-(a.priority||0))[0]||null
    const resolved={...(rule||{}),...(productOverride||{})}
    const minimumCartMet=resolved.minimum_cart===null||resolved.minimum_cart===undefined||normalized.cartSubtotal===null?null:normalized.cartSubtotal>=Number(resolved.minimum_cart)
    const freeDelivery=resolved.free_delivery_threshold===null||resolved.free_delivery_threshold===undefined||normalized.cartSubtotal===null?null:normalized.cartSubtotal>=Number(resolved.free_delivery_threshold)
    const hasFee=[resolved.base_fee,resolved.extra_personnel_fee,resolved.special_transport_fee,resolved.operational_surcharge].some((value)=>value!==null&&value!==undefined)
    return {
      status:hasFee?'resolved':'quote_required',
      context:normalized,
      transportMethod:resolved.transport_method||normalized.transportMethod,
      minimumCartMet,
      freeDelivery,
      fees:freeDelivery===true?{base:0,extraPersonnel:0,specialTransport:0,operational:0}:{base:resolved.base_fee??null,extraPersonnel:resolved.extra_personnel_fee??null,specialTransport:resolved.special_transport_fee??null,operational:resolved.operational_surcharge??null},
      source:productOverride?'product_override':rule?'pricing_rule':'default_pending'
    }
  }
  const validClasses=new Set(['S','M','L'])
  const validMethods=new Set(['grey_owned_vehicle_and_staff','courier','cargo','freight_carrier'])
  const authorizedRoles=new Set(carrierEngine.manual_override?.authorized_roles||[])
  const resolveManualOverride=(override)=>{
    if(!override) return null
    const valid=authorizedRoles.has(override.role)&&validMethods.has(override.method)&&Boolean(override.approvedBy)&&Boolean(override.reason)
    return valid?{status:'resolved',method:override.method,source:'manual_override',audit:{approvedBy:override.approvedBy,reason:override.reason,role:override.role}}:{status:'manual_override_rejected',method:null,source:'manual_override'}
  }
  const resolveCarrier=(context={})=>{
    const normalizedClass=(context.deliveryClass||deliveryClass||'unclassified').toUpperCase()
    const manual=resolveManualOverride(context.manualOverride)
    if(manual) return manual
    const consolidation=context.consolidation||{}
    if(consolidation.required===true&&consolidation.completeBeforeWindow!==true){
      return {status:'deferred',method:null,source:'consolidation',serviceDay:'next_day',deliveryCount:1,split:false}
    }
    if(!validClasses.has(normalizedClass)) return {status:'review_required',method:null,source:'delivery_class'}
    const baseChecks=[context.zoneSupported,context.stockLocationEligible,context.greyVehicleAvailable,context.greyStaffAvailable]
    const largeChecks=normalizedClass==='L'?[context.vehicleCapacityConfirmed,context.requiredPersonnelConfirmed]:[]
    const checks=[...baseChecks,...largeChecks]
    if(checks.every((value)=>value===true)) return {status:'resolved',method:'grey_owned_vehicle_and_staff',source:'grey_priority'}
    if(checks.some((value)=>value===undefined||value===null)) return {status:'review_required',method:null,source:normalizedClass==='L'?'capacity_or_personnel_unknown':'grey_availability_unknown'}
    const availability=context.externalAvailability||{}
    const priority=carrierEngine.external_priority_by_class?.[normalizedClass]||[]
    const eligible=priority.filter((method)=>availability[method]?.available===true&&availability[method]?.capacityConfirmed===true)
    if(!eligible.length) return {status:'external_selection_required',method:null,source:'grey_unavailable',eligibleMethods:[]}
    return {status:'resolved',method:eligible[0],source:'external_fallback',eligibleMethods:eligible}
  }
  root.greyDeliveryPricing={resolve:resolvePricing,productOverride,engineVersion:pricing.version||null}
  root.greyCarrierDecision={resolve:resolveCarrier,engineVersion:carrierEngine.version||null}
  root.greyDeliveryDecision={resolve:(context={})=>{
    const carrier=resolveCarrier(context)
    const pricingResult=resolvePricing({...context,transportMethod:carrier.method})
    return {carrier,pricing:pricingResult,fulfillment:{consolidation:carrier.source==='consolidation'?'deferred':'preserved',split:false}}
  }}
  const getNicosiaMinutes=()=>{
    const parts=new Intl.DateTimeFormat('en-GB',{timeZone:master.timezone||'Asia/Nicosia',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date())
    const hour=Number(parts.find((part)=>part.type==='hour')?.value||0)
    const minute=Number(parts.find((part)=>part.type==='minute')?.value||0)
    return hour*60+minute
  }
  const cutoffMinutes=()=>{
    const parts=(schedule.cutoff_local||'15:00').split(':').map(Number)
    return parts[0]*60+parts[1]
  }
  root.querySelectorAll('[data-gpa-action]').forEach((button)=>button.addEventListener('click',()=>{
    panel.hidden=false
    const action=button.dataset.gpaAction
    if(action==='stock') result.textContent=root.dataset.resultStock
    if(action==='pickup') result.textContent=root.dataset.resultPickup
    if(action==='delivery'){
      const eligible=master.delivery_classes?.[deliveryClass]?.grey_fleet_eligible===true
      if(!eligible) result.textContent=root.dataset.resultUnclassified
      else result.textContent=getNicosiaMinutes()<=cutoffMinutes()?root.dataset.resultSameDay:root.dataset.resultNextDay
    }
    panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'})
  }))
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grey-service-hub"]) return;
  try {
    
function openGreyServiceTarget(){const key=window.location.hash.slice(1);if(!key)return;const target=document.getElementById(key);if(target?.matches('.gsh__detail')){target.open=true;requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));}}
document.addEventListener('DOMContentLoaded',openGreyServiceTarget);window.addEventListener('hashchange',openGreyServiceTarget);document.addEventListener('click',event=>{const link=event.target.closest('.gsh__topics a');if(!link)return;const target=document.getElementById(link.getAttribute('href').slice(1));if(target)target.open=true;});openGreyServiceTarget();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('hero-slider')) return;

    class HeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
        this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
        this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
        this.nextBtn = this.querySelector('.hero-slider__arrow--next');
        this.track = this.querySelector('.hero-slider__track');
        this.current = 0;
        this.timer = null;

        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplaySeconds = parseInt(this.dataset.autoplaySeconds, 10) || 5;

        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.applyReducedMotion();
        this.reducedMotionQuery.addEventListener('change', () => this.applyReducedMotion());

        if (this.slides.length < 2) return;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
        }
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.go(index));
        });

        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.play());

        this.setupSwipe();
        this.play();
      }

      applyReducedMotion() {
        this.prefersReducedMotion = this.reducedMotionQuery.matches;
        this.classList.toggle('hero-slider--reduced-motion', this.prefersReducedMotion);
        if (this.prefersReducedMotion) {
          this.pause();
        } else if (this.slides && this.slides.length > 1) {
          this.play();
        }
      }

      go(index) {
        const total = this.slides.length;
        this.current = (index + total) % total;
        this.slides.forEach((slide, i) => {
          const active = i === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, i) => {
          const active = i === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.restartAutoplay();
      }

      play() {
        if (!this.autoplayEnabled || this.prefersReducedMotion || this.slides.length < 2) return;
        this.pause();
        this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySeconds * 1000);
      }

      pause() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      restartAutoplay() {
        if (this.autoplayEnabled && !this.prefersReducedMotion) {
          this.play();
        }
      }

      setupSwipe() {
        if (!this.track) return;
        let startX = 0;
        let isDragging = false;

        this.track.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
          isDragging = true;
        }, { passive: true });

        this.track.addEventListener('touchend', (event) => {
          if (!isDragging) return;
          isDragging = false;
          const endX = event.changedTouches[0].clientX;
          const delta = endX - startX;
          if (Math.abs(delta) > 40) {
            if (delta < 0) {
              this.go(this.current + 1);
            } else {
              this.go(this.current - 1);
            }
          }
        }, { passive: true });
      }

      disconnectedCallback() {
        this.pause();
      }
    }

    customElements.define('hero-slider', HeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-hero-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-grey-hero]').forEach((root)=>{
  const slides=[...root.querySelectorAll('[data-slide]')]
  const dots=[...root.querySelectorAll('[data-go]')]
  if(slides.length<2)return
  let current=0
  let timer
  let paused=false
  const show=(index)=>{
    current=(index+slides.length)%slides.length
    slides.forEach((slide,i)=>{
      const active=i===current
      slide.classList.toggle('is-active',active)
      slide.setAttribute('aria-hidden',String(!active))
      slide.inert=!active
    })
    dots.forEach((dot,i)=>{
      const active=i===current
      dot.classList.toggle('is-active',active)
      dot.setAttribute('aria-selected',String(active))
    })
  }
  const start=()=>{
    clearInterval(timer)
    if(!paused&&!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(()=>show(current+1),7000)
  }
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>{show(i);start()}))
  root.querySelector('[data-prev]')?.addEventListener('click',()=>{show(current-1);start()})
  root.querySelector('[data-next]')?.addEventListener('click',()=>{show(current+1);start()})
  root.querySelector('[data-pause]')?.addEventListener('click',(event)=>{
    paused=!paused
    event.currentTarget.textContent=paused?'▶':'Ⅱ'
    event.currentTarget.setAttribute('aria-label',paused?'Otomatik geçişi başlat':'Otomatik geçişi durdur')
    start()
  })
  root.addEventListener('mouseenter',()=>clearInterval(timer))
  root.addEventListener('mouseleave',start)
  root.addEventListener('focusin',()=>clearInterval(timer))
  root.addEventListener('focusout',start)
  show(0)
  start()
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
